const PLUGIN_PREFIX = 'CXF-BANNER-AD'

const logger = {
    info: (...args) => {
        if (process.env.NODE_ENV !== 'production') {
            console.info(
                `%c ${PLUGIN_PREFIX} -> `,
                'background: #2b9348; color: #eeef20',
                ...args
            )
        }
    },
    debug: (...args) => {
        if (process.env.NODE_ENV !== 'production') {
            console.info(
                `%c ${PLUGIN_PREFIX} -> `,
                'background: #e9ecef; color: #343a40',
                ...args
            )
        }
    },
    warn: (...args) => {
        if (process.env.NODE_ENV !== 'production') {
            console.warn(
                `%c ${PLUGIN_PREFIX} -> `,
                'background: #ffdd00; color: #e85d04',
                ...args
            )
        }
    },
    error: (...args) => {
        console.error(
            `%c ${PLUGIN_PREFIX} -> `,
            'background: #d00000; color: #370617',
            ...args
        )
    }
}

export default logger
